// src/features/legacy-reports/useLegacyMediasReport.ts

import { useQuery } from '@tanstack/react-query';
import { LegacyReportsApi } from './LegacyReportsApi';
import {
  LEGACY_REPORTS_QUERY_KEYS,
  legacyMediaIdsKey,
} from '@/lib/constants/legacyReports';
import type { LegacyMediasReport } from './types';

export interface UseLegacyMediasReportResult {
  report: LegacyMediasReport | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

/** Legacy media totals (all media when mediaIds is omitted). */
export function useLegacyMediasReport(
  cId: number | null,
  start: number,
  end: number,
  mediaIds?: number[]
): UseLegacyMediasReportResult {
  const query = useQuery({
    queryKey: LEGACY_REPORTS_QUERY_KEYS.medias(
      cId ?? 0,
      start,
      end,
      legacyMediaIdsKey(mediaIds)
    ),
    queryFn: () => LegacyReportsApi.getMediasReport(cId!, start, end, mediaIds),
    enabled: cId !== null,
  });

  return {
    report: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
